import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export const PackageTableSkeleton = () => {
    const skeletonRows = Array.from({ length: 10 }).map((_, index) => (
        <TableRow key={index}>
            <TableCell><Skeleton className="h-4 w-20" /></TableCell>
            <TableCell className="flex gap-2">
                <Skeleton className="h-8 w-8 rounded-md" />
                <Skeleton className="h-8 w-8 rounded-md" />
            </TableCell>
            <TableCell><Skeleton className="h-4 w-24" /></TableCell>
            <TableCell><Skeleton className="h-4 w-32" /></TableCell>
            <TableCell><Skeleton className="h-4 w-16" /></TableCell>
            <TableCell><Skeleton className="h-4 w-24" /></TableCell>
            <TableCell><Skeleton className="h-8 w-24 rounded-full" /></TableCell>
            <TableCell><Skeleton className="h-4 w-28" /></TableCell>
            <TableCell><Skeleton className="h-8 w-10 rounded-md" /></TableCell>
        </TableRow>
    ));

    return (
        <div className="rounded-md border">
            <Table>
                <TableHeader>
                    <TableRow className="bg-white sticky top-0 z-10 shadow-sm">
                        <TableHead>Sequential #</TableHead>
                        <TableHead>Observations</TableHead>
                        <TableHead>Tracking</TableHead>
                        <TableHead>Guest Name</TableHead>
                        <TableHead>Unit #</TableHead>
                        <TableHead className="text-center">Entry Date</TableHead>
                        <TableHead>Status</TableHead>
                        <TableHead>Last Updated By</TableHead>
                        <TableHead>Actions</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {skeletonRows}
                </TableBody>
            </Table>
        </div>
    );
};

export const PackageGridSkeleton = () => {
    const skeletonCards = Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className="border rounded-lg p-3 flex flex-col justify-between min-h-[320px] bg-white">
            <div className="flex justify-between items-start">
                <Skeleton className="h-4 w-12" />
                <Skeleton className="h-7 w-7 rounded-full" />
            </div>
            <div className="flex-1 flex flex-col justify-between pt-8">
                <div>
                    <Skeleton className="h-6 w-3/4 mb-2" />
                    <div className="flex items-center gap-2 mb-2">
                        <Skeleton className="h-4 w-20 rounded-full" />
                        <Skeleton className="h-4 w-12" />
                        <Skeleton className="h-4 w-24" />
                    </div>
                    <Skeleton className="h-4 w-48 mb-4" />
                    <Skeleton className="h-12 w-20 rounded" />
                </div>
                <div className="flex gap-2 mt-2">
                    <Skeleton className="h-10 w-10 rounded-md" />
                    <Skeleton className="h-10 w-10 rounded-md" />
                </div>
            </div>
            <div className="mt-3 space-y-2">
                <Skeleton className="h-10 w-full" />
                <Skeleton className="h-10 w-full" />
            </div>
        </div>
    ));

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {skeletonCards}
        </div>
    )
} 